import { schemas } from '@repo/contracts'
import { z } from 'zod'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from './errorHandler'

export type OrgTag = z.infer<typeof schemas.apihttp_GetTagsResponse>
const tagsResponseSchema = z.array(schemas.apihttp_GetTagsResponse)

export async function fetchTags(): Promise<Array<OrgTag>> {
  const response = await fetch('/api/tags/', { credentials: 'same-origin' })
  await apiErrorHandler(response)
  return parseDataOfType(await response.json(), tagsResponseSchema)
}

export async function createTag(name: string): Promise<OrgTag> {
  const trimmedName = name.trim()
  if (trimmedName === '') throw new Error('Enter a tag name.')
  // Refresh before writing, including retries after an ambiguous failure.
  const existing = (await fetchTags()).find((tag) => tag.name.trim().toLowerCase() === trimmedName.toLowerCase())
  if (existing) return existing
  const payload = schemas.apihttp_CreateTagRequest.parse({ name: trimmedName, description: '', colour: '#1a5f5a' })
  const response = await fetch('/api/tags/', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
  await apiErrorHandler(response)
  return parseDataOfType(await response.json(), schemas.apihttp_GetTagsResponse)
}
